/**
 * Contains information about features for the home page.
 */

export const gps = {
  title: 'Get Precise Zmanim with GPS',
  icon: 'gps',
  description:
    'Using your phone’s built in GPS hardware, Ultimate Zmanim calculates times for wherever you are. Stop approximating with ZIP codes, and use your precise position. What does “ZIP” even stand for?'
}

export const wifi = {
  title: 'Use with Filters & Without Internet',
  icon: 'wifi',
  description:
    "Sophisticated algorithims enable Ultimate Zmanim to work offline, even when you're on the road. No matter if you're in a car in the wilderness or a on boat off the coast, you'll always know when to stop and daven."
}

export const watch = {
  title: 'Glance at Zmanim on Your Watch',
  icon: 'watch',
  description:
    'Ultimate Zmanim displays the next time directly on your watch face, with complications in every size. It also supports Time Travel and works without your iPhone. A zmanim app on your watch? Oy, what a shidduch!'
}

export const alarms = {
  title: 'Arrive Early with Zmanim Alarms',
  icon: 'alarm',
  description:
    "Ever look at the clock and realize that mincha started two minutes ago? Or that you're already into the 18 minutes? Stop catching mincha and jumping out of the shower. Set your mind at ease with Zmanim alarms and arrive on time - every time."
}

export const print = {
  title: 'Make Beautiful Prints for Shabbat',
  icon: 'print',
  description:
    'Who knows what we read this week? (For 50 parasha points!) When is havdalah? Is that the late zman or early zman? Stop wondering, and print gorgeous sheets for the fridge with wireless printing. For bonus points, hang it in shul, too.'
}

export const toggle = {
  title: 'Choose from 120+ Calculations',
  icon: 'toggle',
  description:
    'As the saying goes, “two jews, three opinions.” Whether you are Ashkenazi, Sepharadi, Chasidish, or in between, Ultimate Zmanim has you covered. With 123 different calculations, you’ll never need another app.  '
}

export const all = [gps, wifi, watch, alarms, print, toggle]
export const free = [gps, wifi, watch]
export const premium = [alarms, print, toggle]
